module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa0906c80d270b3b9e75669f036f30e3b.a0906c80.png";